import UsersSelectionWidget from 'components/FormWidgets/UsersSelectionWidget';
import LocationFieldTemplate from 'components/MuiFormBuilder/CustomFields/LocationField';

const compact = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12,
};

const uiSchema = () => ({
  'ui:order': ['title', 'type_id', 'manager_id', 'location', 'is_active'],
  title: {
    'ui:options': compact,
  },
  manager_id: {
    'ui:widget': UsersSelectionWidget,
    'ui:options': compact,
  },
  type_id: {
    'ui:options': compact,
  },
  location: {
    'ui:field': LocationFieldTemplate,
    'ui:options': {
      confirmLocationChange: true,
    },
  },
  is_active: {
    'ui:widget': 'radio',
    'ui:options': {
      inline: true,
      ...compact,
    },
  },
});

export default uiSchema;
